import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import DisasterRecoveryEmbed from './disaster-recovery-embed';

@NgModule({
    declarations: [
        DisasterRecoveryEmbed,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        DisasterRecoveryEmbed
    ]
})

export class DisasterRecoveryModule {
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/components/disaster-recovery/disaster-recovery.module.ts